<script>
  import Button from './common/Button.svelte'
  import Sharing from './common/Sharing.svelte'

  import { get } from "svelte/store";
  import { stats } from "./stores.js";
</script>

<div class="card card--main dekstop">
  <div class="card__main">
    <div class="card__img"><img src={`./img/slides/win.png`} alt="win" /></div>
    <p>
      Поздравляем, ты дошёл до конца и не упал в грязь лицом. Признавайся, у
      тебя уже есть опыт управления компанией?
    </p>
    <p>Твоё место в рейтинге — {get(stats.rating)}. Супер! А что насчёт нас?</p>
    <p>
      UCMS Group Russia входит в ТОП-3 крупнейших компаний в области расчёта
      заработной платы и кадрового делопроизводства и в ТОП-7 в рейтинге
      компаний в области аутсорсинга учётных функций. Мы уже 25 лет решаем
      задачи клиентов и помогаем им в самых разных ситуациях, включая те, что
      встретились тебе сегодня в игре.
    </p>
    <p>Ну что, попробуешь обогнать нас в рейтинге?</p>
  </div>
  <Button onClick={() => document.location.reload()} text="Уже бегу" />
  <Button onClick={() => (document.location.href = 'https://www.ucmsgroup.ru')} isCenter text="Хочу знать секрет успеха UCMS" />
</div>
<Sharing />
